import { ITypedModel } from 'core-ts-types';
import { Model } from 'utility-ts-orm';

export interface ISTCConfigsData {
  absences_verbiage: string;
  allow_users_to_edit_pronouns: boolean;
  comments_verbiage: string;
  grade_verbiage: string;
  show_absences: boolean;
  show_comments: boolean;
  show_grade: boolean;
  show_pronouns: boolean;
  v3_student_scheduler_flag: boolean;
  self_alert_label: string;
  alert_label: string;
}

export type STCConfigsModel = ITypedModel<ISTCConfigsData>;

angular.module('capability-ng-priority-feed').factory(
  'ngSTCConfigsModel',
  () =>
    new Model<ISTCConfigsData>({
      absences_verbiage: 'Number of Absences',
      allow_users_to_edit_pronouns: false,
      comments_verbiage: 'Additional Comments',
      grade_verbiage: 'Current Grade',
      show_absences: false,
      show_comments: false,
      show_grade: false,
      show_pronouns: false,
      v3_student_scheduler_flag: false,
      self_alert_label: 'Hand Raise',
      alert_label: 'Alert'
    })
);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-priority-feed/src/models/stcconfigs_model.ts